var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.hasCreaAsta
        ? _c("div", { staticClass: "logo-bg" }, [
            _c(
              "div",
              { staticClass: "view" },
              [
                _vm.loading
                  ? _c("NotFound", { attrs: { text: "Loading..." } })
                  : _vm.astaInfo
                  ? _c(
                      "div",
                      { staticClass: "iscrivi-squadra" },
                      [
                        _c(
                          "v-card",
                          {
                            staticClass: "navy darken-1",
                            attrs: { width: "300" },
                          },
                          [
                            _c(
                              "v-card-title",
                              { staticClass: "justify-center white--text" },
                              [
                                _c("div", [
                                  _c("b", [_vm._v("Iscrivi squadra a asta")]),
                                  _c("br"),
                                  _c("i", [_vm._v(_vm._s(_vm.astaInfo.name))]),
                                ]),
                              ]
                            ),
                            _vm._v(" "),
                            _c("v-divider"),
                            _vm._v(" "),
                            _c(
                              "v-card-text",
                              { staticClass: "py-4 px-8" },
                              [
                                !_vm.iscrizioneError
                                  ? _c(
                                      "v-form",
                                      {
                                        ref: "form",
                                        model: {
                                          value: _vm.valid,
                                          callback: function ($$v) {
                                            _vm.valid = $$v
                                          },
                                          expression: "valid",
                                        },
                                      },
                                      [
                                        _c(
                                          "v-row",
                                          { attrs: { dense: "" } },
                                          [
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "3" } },
                                              [
                                                _c(
                                                  "div",
                                                  {
                                                    staticClass: "myPic",
                                                    class: _vm.myPicClass,
                                                    on: {
                                                      click: _vm.showDialog,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "label",
                                                      { staticClass: "label" },
                                                      [_vm._v("Logo")]
                                                    ),
                                                    _vm._v(" "),
                                                    _vm.myPic
                                                      ? _c("img", {
                                                          attrs: {
                                                            src: _vm.myPic,
                                                          },
                                                        })
                                                      : _vm._e(),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "v-col",
                                              { attrs: { cols: "9" } },
                                              [
                                                _c("v-text-field", {
                                                  staticClass: "mb-4",
                                                  attrs: {
                                                    label: "Nome squadra",
                                                    name: "myNomeSquadra",
                                                    "persistent-hint": "",
                                                    required: "",
                                                    outlined: "",
                                                    counter: "",
                                                    maxlength: "50",
                                                    rules: [
                                                      _vm.rules
                                                        .campoObbligatorio,
                                                      _vm.rules.nomeTroppoLungo(
                                                        50
                                                      ),
                                                    ],
                                                    dark: "",
                                                  },
                                                  model: {
                                                    value: _vm.myNomeSquadra,
                                                    callback: function ($$v) {
                                                      _vm.myNomeSquadra = $$v
                                                    },
                                                    expression: "myNomeSquadra",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-btn",
                                          {
                                            staticClass:
                                              "secondary white--text",
                                            attrs: {
                                              rounded: "",
                                              depressed: "",
                                              large: "",
                                              id: "iscrivi-squadra",
                                              disabled: !_vm.valid,
                                            },
                                            on: { click: _vm.iscriviSquadra },
                                          },
                                          [_vm._v("Iscriviti")]
                                        ),
                                      ],
                                      1
                                    )
                                  : _c("div", [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "white--text px-4 py-2",
                                        },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(_vm.iscrizioneError) +
                                              "\n              "
                                          ),
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "mt-4" },
                                        [
                                          _vm.astaInfo.id
                                            ? _c(
                                                "v-btn",
                                                {
                                                  staticClass:
                                                    "secondary white--text",
                                                  attrs: { large: "" },
                                                  on: { click: _vm.gotoAsta },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                  Vai all'Asta\n                "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "mt-4" },
                                        [
                                          _c(
                                            "v-btn",
                                            {
                                              staticClass:
                                                "white-text text-decoration-underline",
                                              attrs: { text: "" },
                                              on: { click: _vm.gotoHome },
                                            },
                                            [
                                              _vm._v(
                                                "\n                  Torna alla Home\n                "
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      ),
                                    ]),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "v-dialog",
                          {
                            attrs: { eager: "", "max-width": "700" },
                            model: {
                              value: _vm.dialog,
                              callback: function ($$v) {
                                _vm.dialog = $$v
                              },
                              expression: "dialog",
                            },
                          },
                          [
                            _c(
                              "v-card",
                              { staticClass: "navy darken-1" },
                              [
                                _c(
                                  "v-card-title",
                                  { staticClass: "white--text" },
                                  [_vm._v("Scegli logo")]
                                ),
                                _vm._v(" "),
                                _c("v-divider"),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "pics",
                                    class: { "nice-scroll": !_vm.is_mobile },
                                  },
                                  _vm._l(
                                    _vm.defaultPics,
                                    function (pic, index) {
                                      return _c(
                                        "div",
                                        {
                                          key: index,
                                          staticClass: "pic navy darken-2",
                                          on: {
                                            click: function ($event) {
                                              return _vm.saveMyPic(pic)
                                            },
                                          },
                                        },
                                        [_c("img", { attrs: { src: pic } })]
                                      )
                                    }
                                  ),
                                  0
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _c("NotFound", {
                      attrs: {
                        text: "Asta non esistente o link di invito non valido",
                      },
                    }),
              ],
              1
            ),
          ])
        : _c("NotFound"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }